import React, { useState } from "react";
import CustomSelect from "../../../../../Base/CustomSelect";
import Amount from "../../../../../Base/Amount";
const networksList = [
  {
    id: "1",
    value: "Ethereum",
    icon: "/images/networks/eth.svg",
  },
  {
    id: "2",
    value: "Binance",
    icon: "/images/networks/binance.svg",
  },
  {
    id: "3",
    value: "Avalanche",
    icon: "/images/networks/avalanche.svg",
  },
];
const tokensList = [
  {
    id: "1",
    value: "ETH",
    icon: "/images/networks/eth.svg",
  },
  {
    id: "2",
    value: "BUSD",
    icon: "/images/networks/binance.svg",
  },
  {
    id: "3",
    value: "USDT",
    icon: "/images/tokens/tether.svg",
  },
];
const defaultProps = {
  network: "Ethereum",
  token: "BUSD",
  description: "",
  amount: "0",
  nft: false,
  currency: "$",
};
export default function More() {
  const [form, setForm] = useState({
    network: "Ethereum",
    token: "BUSD",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra id adipiscing id dignissim sed donec. Leo suspendisse non in nulla neque massa metus, sed. Eget amet tincidunt sed montes, quis. ",
    amount: "100",
    nft: false,
    currency: "$",
  });
  const onChangeInput = (input) => (e) => {
    setForm((form) => ({ ...form, [input]: e.target.value }));
  };
  const updateForm = (data) => {
    setForm((form) => ({ ...form, ...data }));
  };
  const changeMedium = (key) => (item) => updateForm({ [key]: item.value });
  const networkListIndex = React.useMemo(() => {
    if (form.network !== "") {
      return networksList.findIndex((item) => item.value === form.network);
    }
    return null;
    // eslint-disable-next-line
  }, []);
  const tokensListIndex = React.useMemo(() => {
    if (form.token !== "") {
      return tokensList.findIndex((item) => item.value === form.token);
    }
    return null;
    // eslint-disable-next-line
  }, []);
  return (
    <div className="preview">
      <h5>
        <span className="purple"></span> Profile information
      </h5>
      <div className="preview__inner">
        <div className="previewInfo">
          <div className="previewInfo__head">
            <div className="avatar">
              <img
                src={process.env.PUBLIC_URL + "/images/avatar.png"}
                alt="avatar"
              />
            </div>
            <div className="previewInfo__head-text">
              <h4>Bored Ape</h4>
              <span className="status">In progress</span>
            </div>
          </div>
          <div className="previewInfo__body">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra id
            adipiscing id dignissim sed donec. Leo suspendisse non in nulla
            neque massa metus, sed. Eget amet tincidunt sed montes, quis.
          </div>
        </div>
        <div className="previewRequest">
          <div className="request">
            <div className="request__row">
              <label htmlFor="">Network</label>
              <CustomSelect
                list={networksList}
                selected={networksList[networkListIndex]}
                onChange={changeMedium("network")}
              />
            </div>
            <div className="request__row">
              <label htmlFor="">Token</label>
              <CustomSelect
                list={tokensList}
                selected={tokensList[tokensListIndex]}
                onChange={changeMedium("token")}
              />
            </div>
            <Amount
              onChangeInput={onChangeInput}
              form={form}
              updateForm={updateForm}
            />
            <div className="input__outer mb">
              <label htmlFor="">Description</label>
              <div className="input">
                <textarea
                  name=""
                  id=""
                  cols="30"
                  rows="3"
                  value={form.description}
                  onChange={onChangeInput("description")}
                ></textarea>
              </div>
            </div>
            <div className="request__row">
              <label htmlFor="">Create NFT</label>
              <div className="radio">
                <input type="radio" name="nft" />
                <label htmlFor=""></label>
              </div>
            </div>
            <div className="request__row">
              <label htmlFor="">Don’t create NFT</label>
              <div className="radio">
                <input type="radio" name="nft" />
                <label htmlFor=""></label>
              </div>
            </div>
            <div className="request__footer">
              <div
                className="button bordered"
                onClick={() => setForm(defaultProps)}
              >
                Reset all
              </div>
              <div className="button primary">Save all</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
